// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { AlertsAreaRoutes } from '@backoffice-frontend/alerts-common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { AlertsAreaId } from './AlertsAreaId'

import {
  AlertsAreaNavigation,
  AlertsAreaNavigationIcon,
} from './AlertsAreaNavigation'

const LazyAlertsComponent = lazy(() => import('./AlertsArea'))

const AlertsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAlertsComponent />
  </SuspenseLoadingWrapper>
)

export const AlertsArea = {
  id: AlertsAreaId,
  requiredRight: BoumRight.AREA_ALERTS,
  Icon: AlertsAreaNavigationIcon,
  NavigationComponent: AlertsAreaNavigation,
  route: {
    path: AlertsAreaRoutes.route,
    component: AlertsComponent,
  },
}
